// Cópia profunda do estado. O estado é só dado puro (objetos, arrays, números,
// textos, booleanos e null), então uma cópia recursiva simples basta e é bem mais
// rápida que structuredClone para muitos objetos pequenos.

export function deepClone<T>(value: T): T {
  if (value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) {
    const out = new Array(value.length);
    for (let i = 0; i < value.length; i++) out[i] = deepClone(value[i]);
    return out as T;
  }
  const out: Record<string, unknown> = {};
  for (const k in value as Record<string, unknown>) {
    const v = (value as Record<string, unknown>)[k];
    if (v !== undefined) out[k] = deepClone(v);
  }
  return out as T;
}
